{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "您已超過對話數量上限。Hacker 方案僅允許 500 則對話。",
      "INBOXES": "您已超過收件匣數量上限。Hacker 方案僅支援網站即時聊天。如需使用電子郵件、WhatsApp 等額外收件匣，請升級至付費方案。",
      "AGENTS": "您已超過客服人員數量上限。您的方案僅允許 {allowedAgents} 位客服人員。",
      "NON_ADMIN": "請聯絡您的管理員升級方案，以繼續使用所有功能。"
    },
    "TITLE": "帳戶設定",
    "SUBMIT": "更新設定",
    "BACK": "返回",
    "DISMISS": "關閉",
    "UPDATE": {
      "ERROR": "無法更新設定，請重試！",
      "SUCCESS": "已成功更新帳戶設定"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "刪除您的帳戶",
      "NOTE": "一旦刪除帳戶，您的所有資料將被永久刪除。",
      "BUTTON_TEXT": "刪除您的帳戶",
      "CONFIRM": {
        "TITLE": "刪除帳戶",
        "MESSAGE": "刪除帳戶後將無法復原。請在下方輸入您的帳戶名稱以確認永久刪除。",
        "BUTTON_TEXT": "刪除",
        "DISMISS": "取消",
        "PLACE_HOLDER": "請輸入 {accountName} 以確認"
      },
      "SUCCESS": "帳戶已標記為待刪除",
      "FAILURE": "無法刪除帳戶，請重試！",
      "SCHEDULED_DELETION": {
        "TITLE": "帳戶已排定刪除",
        "MESSAGE_MANUAL": "此帳戶已排定於 {deletionDate} 刪除。此操作由管理員發起，您可以在該日期之前取消刪除。",
        "MESSAGE_INACTIVITY": "此帳戶因長期未使用，已排定於 {deletionDate} 刪除。您可以在該日期之前取消刪除。",
        "CLEAR_BUTTON": "取消排定刪除"
      }
    },
    "FORM": {
      "ERROR": "請修正表單錯誤",
      "GENERAL_SECTION": {
        "TITLE": "一般設定",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "帳戶 ID",
        "NOTE": "如果您正在建立基於 API 的整合，將需要此 ID"
      },
      "AUTO_RESOLVE": {
        "TITLE": "自動解決對話",
        "NOTE": "此設定可讓您在一段時間無活動後自動解決對話。",
        "DURATION": {
          "LABEL": "無活動持續時間",
          "HELP": "對話在無活動多久後自動解決",
          "PLACEHOLDER": "30",
          "ERROR": "自動解決時間應介於 10 分鐘至 999 天之間",
          "API": {
            "SUCCESS": "已成功更新自動解決設定",
            "ERROR": "無法更新自動解決設定"
          }
        },
        "MESSAGE": {
          "LABEL": "自訂自動解決訊息",
          "PLACEHOLDER": "由於 15 天無活動，此對話已被系統標記為已解決",
          "HELP": "對話自動解決後傳送給客戶的訊息"
        },
        "PREFERENCES": "偏好設定",
        "LABEL": {
          "LABEL": "自動解決後新增標籤",
          "PLACEHOLDER": "選擇標籤"
        },
        "IGNORE_WAITING": {
          "LABEL": "跳過等待客服回覆的對話"
        },
        "UPDATE_BUTTON": "儲存變更"
      },
      "NAME": {
        "LABEL": "帳戶名稱",
        "PLACEHOLDER": "您的帳戶名稱",
        "ERROR": "請輸入有效的帳戶名稱"
      },
      "LANGUAGE": {
        "LABEL": "網站語言",
        "PLACEHOLDER": "您的帳戶名稱",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "接收電子郵件的網域",
        "PLACEHOLDER": "用於接收郵件的網域",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "客服信箱",
        "PLACEHOLDER": "您公司的客服信箱",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "排除未回覆的對話",
        "HELP": "啟用後，系統將跳過仍在等待客服回覆的對話，不會自動解決。"
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "語音訊息轉文字",
        "NOTE": "自動將對話中的語音訊息轉為文字。每當傳送或接收語音訊息時，系統會自動產生文字稿並顯示在訊息旁。",
        "API": {
          "SUCCESS": "已成功更新語音轉文字設定",
          "ERROR": "無法更新語音轉文字設定"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "無活動自動解決時間",
        "HELP": "對話在無活動多久後應自動解決",
        "PLACEHOLDER": "30",
        "ERROR": "自動解決時間應介於 10 分鐘至 999 天之間",
        "API": {
          "SUCCESS": "已成功更新自動解決設定",
          "ERROR": "無法更新自動解決設定"
        },
        "UPDATE_BUTTON": "更新",
        "MESSAGE_LABEL": "自訂解決訊息",
        "MESSAGE_PLACEHOLDER": "由於 15 天無活動，此對話已被系統標記為已解決",
        "MESSAGE_HELP": "當對話因無活動而被系統自動解決時，此訊息將傳送給客戶。"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "您的帳戶已啟用電子郵件對話延續功能。",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "您現在可以在自訂網域的信箱中接收郵件。"
      }
    },
    "UPDATE_CHATWOOT": "Chatwoot 有新版本 {latestChatwootVersion} 可供更新，請更新您的執行個體。",
    "LEARN_MORE": "瞭解更多",
    "PAYMENT_PENDING": "您的付款尚未完成，請更新付款資訊以繼續使用 Chatwoot",
    "UPGRADE": "升級以繼續使用 Chatwoot",
    "LIMITS_UPGRADE": "您的帳戶已超過使用量上限，請升級方案以繼續使用 Chatwoot",
    "OPEN_BILLING": "開啟帳單"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "按下 Enter 以選擇",
      "ENTER_TO_REMOVE": "按下 Enter 以移除",
      "NO_OPTIONS": "清單為空",
      "SELECT_ONE": "選擇其中一項",
      "SELECT": "選擇"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "通知",
    "MARK_ALL_DONE": "全部標記完成",
    "DELETE_TITLE": "已刪除",
    "UNREAD_NOTIFICATION": {
      "TITLE": "未讀通知",
      "ALL_NOTIFICATIONS": "查看所有通知",
      "LOADING_UNREAD_MESSAGE": "正在載入未讀通知...",
      "EMPTY_MESSAGE": "您沒有未讀通知"
    },
    "LIST": {
      "LOADING_MESSAGE": "正在載入通知...",
      "404": "沒有通知",
      "TABLE_HEADER": [
        "姓名",
        "電話號碼",
        "對話",
        "最後聯絡"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "新對話",
      "conversation_assignment": "對話已指派",
      "assigned_conversation_new_message": "新訊息",
      "participating_conversation_new_message": "新訊息",
      "conversation_mention": "被提及",
      "sla_missed_first_response": "SLA 未達標",
      "sla_missed_next_response": "SLA 未達標",
      "sla_missed_resolution": "SLA 未達標"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "離線",
      "RECONNECTING": "重新連線中...",
      "RECONNECT_SUCCESS": "已重新連線"
    },
    "BUTTON": {
      "REFRESH": "重新整理"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "搜尋或快速跳轉",
    "SNOOZE_PLACEHOLDER": "輸入時間，例如：明天、2 小時後、下週五、1月15日...",
    "SECTIONS": {
      "GENERAL": "一般",
      "REPORTS": "報表",
      "CONVERSATION": "對話",
      "BULK_ACTIONS": "批次操作",
      "CHANGE_ASSIGNEE": "變更負責人",
      "CHANGE_PRIORITY": "變更優先順序",
      "CHANGE_TEAM": "變更團隊",
      "SNOOZE_CONVERSATION": "延後對話",
      "ADD_LABEL": "為對話新增標籤",
      "REMOVE_LABEL": "從對話移除標籤",
      "SETTINGS": "設定",
      "AI_ASSIST": "AI 助手",
      "APPEARANCE": "外觀",
      "SNOOZE_NOTIFICATION": "延後通知"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "前往對話儀表板",
      "GO_TO_CONTACTS_DASHBOARD": "前往聯絡人儀表板",
      "GO_TO_REPORTS_OVERVIEW": "前往報表總覽",
      "GO_TO_CONVERSATION_REPORTS": "前往對話報表",
      "GO_TO_AGENT_REPORTS": "前往客服人員報表",
      "GO_TO_LABEL_REPORTS": "前往標籤報表",
      "GO_TO_INBOX_REPORTS": "前往收件匣報表",
      "GO_TO_TEAM_REPORTS": "前往團隊報表",
      "GO_TO_SETTINGS_AGENTS": "前往客服人員設定",
      "GO_TO_SETTINGS_TEAMS": "前往團隊設定",
      "GO_TO_SETTINGS_INBOXES": "前往收件匣設定",
      "GO_TO_SETTINGS_LABELS": "前往標籤設定",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "前往預設回覆設定",
      "GO_TO_SETTINGS_APPLICATIONS": "前往應用程式設定",
      "GO_TO_SETTINGS_ACCOUNT": "前往帳戶設定",
      "GO_TO_SETTINGS_PROFILE": "前往個人資料設定",
      "GO_TO_NOTIFICATIONS": "前往通知",
      "ADD_LABELS_TO_CONVERSATION": "為對話新增標籤",
      "ASSIGN_AN_AGENT": "指派客服人員",
      "AI_ASSIST": "AI 助手",
      "ASSIGN_PRIORITY": "指派優先順序",
      "ASSIGN_A_TEAM": "指派團隊",
      "MUTE_CONVERSATION": "將對話靜音",
      "UNMUTE_CONVERSATION": "取消對話靜音",
      "REMOVE_LABEL_FROM_CONVERSATION": "從對話移除標籤",
      "REOPEN_CONVERSATION": "重新開啟對話",
      "RESOLVE_CONVERSATION": "解決對話",
      "SEND_TRANSCRIPT": "傳送對話記錄電子郵件",
      "SNOOZE_CONVERSATION": "延後對話",
      "UNTIL_NEXT_REPLY": "直到下次回覆",
      "UNTIL_NEXT_WEEK": "直到下週",
      "UNTIL_TOMORROW": "直到明天",
      "UNTIL_NEXT_MONTH": "直到下個月",
      "AN_HOUR_FROM_NOW": "一小時後",
      "UNTIL_CUSTOM_TIME": "自訂時間...",
      "CHANGE_APPEARANCE": "變更外觀",
      "LIGHT_MODE": "淺色",
      "DARK_MODE": "深色",
      "SYSTEM_MODE": "跟隨系統",
      "SNOOZE_NOTIFICATION": "延後通知"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "正在載入儀表板應用程式..."
  },
  "COMMON": {
    "OR": "或",
    "CLICK_HERE": "點擊這裡"
  }
}
